import React from 'react';
import { Text } from '@naf/text';
import { ButtonLink } from '@naf/button-link';
import { Campaign } from '../../../../../../types/benefitsType';
import { BenefitDiscountCopy } from '../../../../components/BenefitDiscountCopy/BenefitDiscountCopy';
import * as S from './Styles';

type Props = {
  campaign: Campaign;
  isAuthenticated: boolean;
  onLoginClick: () => void;
};

export const CampaignDiscount = ({ campaign, isAuthenticated, onLoginClick }: Props) => {
  const { discountCodes, accessDetails } = campaign;

  const showDiscountCode = accessDetails?.isAccessibleForUser && discountCodes?.length;
  const showLoginButton = !accessDetails?.isAccessibleForUser && accessDetails?.hasDiscountCodes && !isAuthenticated;
  const showBecomeMemberButton =
    isAuthenticated && !accessDetails?.isAccessibleForUser && accessDetails?.hasDiscountCodes;

  if (showDiscountCode) {
    return (
      <>
        {discountCodes.map((code) => (
          <S.CampaignDiscountWrapper key={`discountCode-${code.discountCode}`}>
            <BenefitDiscountCopy label={code.label} discountCode={code.discountCode} variant={code.variant} />
          </S.CampaignDiscountWrapper>
        ))}
      </>
    );
  }

  if (showLoginButton) {
    return (
      <S.DiscountStateWrapper>
        <ButtonLink onClick={onLoginClick} text="Logg inn for å få kampanjekode" />
      </S.DiscountStateWrapper>
    );
  }

  if (showBecomeMemberButton) {
    return (
      <S.DiscountStateWrapper>
        <Text>Du må være medlem for å få tilgang til rabattkoden.</Text>
      </S.DiscountStateWrapper>
    );
  }

  return null;
};
